import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { saleStatusMessages } from './messages'
import { GTTripV2SaleStatus } from 'gql/types.generated'
import { ReactElement } from 'react'

const SaleStatus = styled.div<TSFixMe>`
  text-transform: capitalize;
  font-weight: 500;
  white-space: nowrap;
  border-radius: 24px;
  color: #fff;
  width: 96px;
  height: 24px;
  text-align: center;
  font-size: 14px;
  line-height: 24px;

  ${({ saleStatus }): TSFixMe => {
    let backgroundColor

    switch (saleStatus) {
      case GTTripV2SaleStatus.Activated:
        backgroundColor = '#00C875'
        break
      case GTTripV2SaleStatus.Deactivated:
        backgroundColor = '#B0B0B0'
        break
    }

    return `background-color: ${backgroundColor};`
  }}
`

interface ITripSaleStatusProps {
  saleStatus: GTTripV2SaleStatus
}

export const TripSaleStatus = ({ saleStatus }: ITripSaleStatusProps): ReactElement => {
  const intl = useIntl()

  if (saleStatusMessages[saleStatus]) {
    return <SaleStatus saleStatus={saleStatus}>{intl.formatMessage(saleStatusMessages[saleStatus])}</SaleStatus>
  }

  return <div>{saleStatus}</div>
}
